exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mt-2[data-v-0b10aae7]{margin-top:15px}.mt-4[data-v-0b10aae7]{margin-top:30px}li[data-v-0b10aae7]{margin-top:15px;font-size:.875rem!important}.fa-circle[data-v-0b10aae7]{font-size:10px;position:relative;top:-1px;margin-right:5px}a[data-v-0b10aae7]:hover{opacity:.8}", ""]);

// exports
